__turbopack_export_value__({
  "dot": "SliderDot-module-scss-module__GwwVxa__dot",
});
